import ExperienceTheFuture from '@/Components/HRMSPortals/ExperienceTheFuture'
import Header from '@/Components/HRMSPortals/Header'
import HRManagementInAction from '@/Components/HRMSPortals/HRManagementInAction'
import WhyChooseHRMSPORTALS from '@/Components/HRMSPortals/WhyChooseHRMSPORTALS'

const HrmsPortals = () => {
    return (
        <div className='bg-[#fbfbfb]'>
            <Header />
            <ExperienceTheFuture />
            <HRManagementInAction />
            <WhyChooseHRMSPORTALS />
        </div>
    )
}
export default HrmsPortals
